import React from 'react';
import styled from 'styled-components';
import { arrayOf, bool, string } from 'prop-types';

import { Label } from 'semantic-ui-react';
import Section from '~/views/common/Section';

import mapping from '~/utils/mapping.json';


const LicenseList = styled.ul`
    display: felx;
    flex-wrap: wrap;
    list-style: none;
`;

const LicenseItem = styled.li`
    margin-right: 5px;
    margin-bottom: 5px;
`;


const Licenses = ({ licenses = [], systemPortal = false }) => (
    <Section name="Licenses">
        { licenses.length ? (
            <LicenseList>
                { licenses.map(productID => (
                    <LicenseItem key={productID}>
                        { systemPortal ?
                            <Label content={mapping.license.by_id_system[productID]} icon="certificate" />
                            :
                            <Label content={mapping.license.by_id[productID]} icon="certificate" />
                        }
                    </LicenseItem>
                )) }
            </LicenseList>
        ) : (
            <div>Not found</div>
        ) }
    </Section>
);


Licenses.propTypes = {
    licenses: arrayOf(string),
    systemPortal: bool,
};

export default Licenses;
